import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Globals } from '../../globals';
import { HttpErrorResponse } from '@angular/common/http';
import { Alert } from 'selenium-webdriver';
import { McqService } from '../../service/mcq.service';

@Component({
  selector: 'app-common-instruction',
  templateUrl: './common-instruction.component.html',
  styleUrls: ['./common-instruction.component.css'],
  providers: [McqService]
})
export class CommonInstructionComponent implements OnInit {


  @Input() paperId: any = 0;

  marked = false;
  packageList: any = [];
  isError = false;
  msg = '';

  constructor(private mcqservice: McqService, private router: Router, private route: ActivatedRoute, private global: Globals) { }

  ngOnInit() {
    if (this.paperId > 0) {
      //console.log('papert id',this.paperId);
      let filter = {};
      filter = { limit: 1 };
      this.getStudentQuizList(filter);
    }
  }

  getStudentQuizList(obj) {
    this.msg = '';
    this.isError = false;

    obj['offset'] = 0;
    obj['testPaperId'] = this.paperId;
    obj['status'] = 'undefined';
    this.mcqservice.getStudentQuizList(obj).subscribe((data: any) => {
      let finaldata = [];
      if (data.error == 0) {
        if (data.results.rows.length > 0) {
          this.packageList = data.results.rows[0];
          this.isError = false;
          //console.log('gg',this.packageList);
        } else {
          this.isError = true;
          this.msg = 'No paper found. Some thing went wrong. Please re-open quiz window.';
        }

      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.isError = true;
      this.msg = "internal server error!";
    });
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/online-mcq/common-instruction/common-instruction.component.ts